export default String.raw`
.breadcrumbs {
  padding: 32px 0 24px;
  
  li {
    font-size: 14px;
    font-family: $fontFamily, sans-serif;
    color: $breadcrumbs;
    display: inline-block;
    vertical-align: top;
    line-height: 20px;
    font-weight: 400;
    &:last-child {
      margin: 0;
    }
    
    a {
      text-decoration: none;
    }
    &:after {
      content: '/';
      display: inline-block;
      margin: 0 6px 0 8px;
      vertical-align: top;
    }
    &:last-child:after {
      display: none;
    }
  }
}
`